module.exports = __webpack_public_path__ + "static/media/C2.1c788f4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C2.mp4
// module id = 6lmM
// module chunks = 8